export const getIsCustomGroupMap = groups => {
  const result = {};
  groups.forEach(gr => {
    if (!gr.is_default) result[gr.id] = true;
  });
  return result;
};
